module.exports = __webpack_public_path__ + "static/img/sh.86a15e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/doctor/sh.jpg
// module id = vg3M
// module chunks = 1